
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/licence-renewals/[city]",
      function () {
        return require("private-next-pages/licence-renewals/[city]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/licence-renewals/[city]"])
      });
    }
  